import type { ElementType, ReactNode } from 'react';

import styles from './Container.module.css';

/** `default` — публичные страницы (1200 px), `app` — оболочка приложения (1440 px). */
type ContainerWidth = 'default' | 'app' | 'report' | 'narrow';

interface ContainerProps {
  children: ReactNode;
  as?: ElementType | undefined;
  width?: ContainerWidth | undefined;
  className?: string | undefined;
}

/** Ограничение ширины контента (DESIGN_SYSTEM §4.3). */
export function Container({
  children,
  as: Tag = 'div',
  width = 'default',
  className,
}: ContainerProps) {
  return (
    <Tag className={[styles.container, styles[width], className].filter(Boolean).join(' ')}>
      {children}
    </Tag>
  );
}
